import Constants from '@intercom/embercom-composer/lib/constants';
import TypeAhead from '@intercom/embercom-composer/components/base/type-ahead';
import intercomDomain from '@intercom/embercom-composer/lib/intercom-domain';
import { inject as service } from '@ember/service';
import Em from 'ember';
export default TypeAhead.extend({
  type: 'mention',
  triggerCharacter: '@',
  triggerWidth: 13,
  inboxService: service(),
  conversationAccessService: service(),
  selectableItems: Em.computed('app.humanAdmins', function () {
    let isMentionDisabled = false;
    let selectableItems = [];
    let admins = this.get('app.humanAdmins') || [];
    admins.forEach(admin => {
      if (this.app && this.app.canUseRestrictConversationAccess && this.inboxService && this.inboxService.currentConversation && this.conversationAccessService) {
        let conversation = this.inboxService.currentConversation;
        isMentionDisabled = !this.conversationAccessService.isConversationAccessAllowed(conversation, admin);
      }
      let name = admin.get('name');
      let key = `@${name}`;
      selectableItems.push(Em.Object.create({
        key,
        id: admin.get('id'),
        avatarData: admin.get('avatarData'),
        isDisabled: isMentionDisabled,
        name
      }));
    });
    return selectableItems;
  }),
  matchingItems: Em.computed('query', function () {
    let query = this.get('query');
    if (query === '') {
      return [];
    }
    let items = this.get('items');
    let matchingItems = items.find(query);
    if (matchingItems) {
      matchingItems.setEach('isHighlighted', false);
      let firstItem = matchingItems.get('firstObject');
      if (firstItem && !firstItem.isDisabled) {
        firstItem.set('isHighlighted', true);
      }
    }
    return matchingItems;
  }),
  init() {
    this._super(...arguments);
    this.set('sortKeys', [{
      key: 'name'
    }]);
  },
  insertItem(admin) {
    let mentionURL = `//${intercomDomain}/apps/${this.get('app.id')}/admin/${admin.get('id')}`;
    this.clearTypedContent();
    let content = admin.get('name').replace(Constants.ZERO_WIDTH_SPACE_GLOBAL_REGEX, '');
    let entityType = 'mention';
    let entityProperties = {
      href: mentionURL
    };
    return this.insertContentAndApplyEntity(content, entityType, entityProperties);
  }
});